<template>
  <!-- 左下角固定二维码组件 (仅PC端显示) -->
  <div :class="['qr-code-widget', 'd-none', 'd-lg-block', isExpanded ? 'expanded' : 'collapsed']" v-show="isVisible">
    <!-- 二维码主体内容 -->
    <div class="qr-main-content" @click="handleMainContentClick">
      <div class="qr-body">
        <img src="@/assets/images/39down.png" alt="下载二维码" class="qr-image">
        <p class="qr-description">扫描下载39游戏盒子有惊喜</p>
      </div>
      <!-- 右侧控制按钮 -->
      <div class="qr-control-btn" @click.stop="hideQrCode">
        <img style=" height: 14px;" src="@/assets/images/arrow_left.png" alt="">
      </div>
    </div>

    <!-- 收起状态的展开按钮 -->
    <div class="qr-collapsed-btn" @click="showQrCode">
      <img style=" height: 14px;transform: rotate(180deg);" src="@/assets/images/arrow_left.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'QrCodeWidget',
  data() {
    return {
      isExpanded: true,
      isVisible: true
    }
  },
  computed: {
    
  },
  methods: {
    toggleQrCode() {
      this.isExpanded = !this.isExpanded
    },

    showQrCode() {
      this.isExpanded = true
    },

    hideQrCode() {
      this.isExpanded = false
    },

    show() {
      this.isVisible = true
      this.isExpanded = true
    },

    hide() {
      this.isVisible = false
    },

    handleMainContentClick(event) {
      // 点击主体内容区域不做任何操作，保持展开状态
      event.stopPropagation()
    },

    handleKeydown(event) {
      if (event.key === 'Escape' && this.isExpanded) {
        this.hideQrCode()
      }
    }
  },

  mounted() {
    // 监听键盘事件
    document.addEventListener('keydown', this.handleKeydown)
  },

  beforeDestroy() {
    // 清理事件监听器
    document.removeEventListener('keydown', this.handleKeydown)
  }
}
</script>

<style scoped>
</style>